import GlobalDispatcher from '../../events/GlobalDispatcher';
import SoundManager from "Engine/soundManager/SoundManager";

export default class BaseGameSettings {
    constructor() {
        this._soundMute = false;
        this._musicMute = false;
        this._quickSpin = false;
        this._infroScreen = true;
    }

    init() {
        GlobalDispatcher.dispatch('gameSettings:init');
        this.addListeners();
    }

    addListeners() {

    }

    get soundMute() {
        return this._soundMute;
    }

    set soundMute(value) {
        this._soundMute = value;
        SoundManager.muteGroup('default', this.soundMute);
        GlobalDispatcher.dispatch('gameSettings:soundMute', this.soundMute);
    }

    get musicMute() {
        return this._musicMute;
    }

    set musicMute(value) {
        this._musicMute = value;
        SoundManager.muteGroup('music', this.musicMute);
        GlobalDispatcher.dispatch('gameSettings:musicMute', this.musicMute);
    }

    get quickSpin() {
        return this._quickSpin;
    }

    set quickSpin(value) {
        this._quickSpin = value;
        GlobalDispatcher.dispatch('gameSettings:quickSpin', this.quickSpin);
    }

    get introScreen() {
        return this._introScreen;
    }

    set introScreen(value) {
        this._introScreen = value;
        GlobalDispatcher.dispatch('gameSettings:introScreen', this.introScreen);
    }
}